module.exports = __webpack_public_path__ + "img/hall-of-fame_1.cbe89fd7.jpg";